import { TextButton as Button, Size } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectMarket, selectTranslateWithAi, setToggleTranslateWithAi } from '../store/slices/globalConfigSlice';
import { marketList } from '../model/constants/marketContants';
import TranslationBanner from './TranslationBanner';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
const TranslateContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

interface TranslateWithAIProps {
  isMedicalProduct?: boolean;
  hideBanner?: boolean;
}

const TranslateWithAI = ({ isMedicalProduct, hideBanner }: TranslateWithAIProps) => {
  const { t } = useTranslation("articles");
  const currentMartket = useSelector(selectMarket);
  const dispatch = useDispatch();
  const translateWithAi = useSelector(selectTranslateWithAi);

  if (isMedicalProduct)
    return <></>;

  return (
    <Container>
      {/* when translated, the banner's "Show original" link replaces this button */}
      {!translateWithAi &&
        <TranslateContainer>
          <Button
            variant="tertiary"
            size={Size.Small}
            invertFocus={false}
            onClick={() => {
              //@ts-ignore
              posthog.capture('SUPP-TranslateContent', {
                market: currentMartket,
                language: marketList[currentMartket].language,
              });
              dispatch(setToggleTranslateWithAi(true));

            }}>
            {t('Translate with AI', { ns: 'articles' })}
          </Button>
        </TranslateContainer>
      }
      {!hideBanner && <TranslationBanner />}
    </Container>
  );
}

export default TranslateWithAI;